// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"cb949a6d","703":"f1fbffd6"}[chunkId] + ".chunk.js";
};